import styled from 'styled-components';

export const TitleWrapper = styled.div``;
export const TitleText = styled.h1`
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 300;
  color: ${({ theme }) => theme.colors.grey.light};
`;

export const Date = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 700;
  font-size: 16px;
`;
